import { render, staticRenderFns } from "./MspAttivitaCiclismo.vue?vue&type=template&id=2c16b48a"
import script from "./MspAttivitaCiclismo.vue?vue&type=script&lang=js"
export * from "./MspAttivitaCiclismo.vue?vue&type=script&lang=js"
import style0 from "./MspAttivitaCiclismo.vue?vue&type=style&index=0&id=2c16b48a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports